import Button from '@yoti/react-components/button';
import React from 'react';
import { MediaQuery, useMediaQuery } from '../../../hooks';
import { RequestData } from '../../../hooks/usePredict';
import { PredictionResponse } from '../../../models/prediction';
import Config from '../../../utils/config';
import { HeaderTab } from '../../commons';
import { ConfigProps } from '../../config/ConfigPanel';
import TimeoutCircularLoading, {
    DEFAULT_LOADING_MESSAGE,
    TIMEOUT_MESSAGE,
} from '../../timeout-loading';
import AgeAntispoofingResponse from './AgeAntispoofingResponse';
import styles from './resultAgeAntispoofing.module.scss';

interface Props {
    image: string;
    result?: PredictionResponse;
    onBackButtonClick: () => void;
    configuration: ConfigProps;
    request?: RequestData;
}

const ResultAgeAntispoofing: React.FC<Props> = (props) => {
    const { image, result, onBackButtonClick, configuration, request } = props;

    const isLaptop = useMediaQuery(MediaQuery.lg);

    return (
        <div className={styles['result']}>
            <HeaderTab className={styles['result__header']} tabs={['Result']} />
            <div className={styles['result__panel']}>
                <img
                    className={styles['result__panel__image']}
                    src={image}
                    alt="face"
                    data-qa="image-captured"
                />
                <div className={styles['result__panel__response']}>
                    {result ? (
                        <AgeAntispoofingResponse
                            responseData={result}
                            configuration={configuration}
                            request={request}
                        />
                    ) : (
                        <TimeoutCircularLoading
                            size={isLaptop ? '80px' : '40px'}
                            message={DEFAULT_LOADING_MESSAGE}
                            timeoutMessage={TIMEOUT_MESSAGE}
                            timeout={Config.slowRequestNotificationTime}
                        />
                    )}
                </div>
            </div>
            <div className={styles['result__back-button']}>
                <Button onClick={onBackButtonClick}>Try again</Button>
            </div>
        </div>
    );
};

export default ResultAgeAntispoofing;
